(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', event => {
 document.querySelectorAll('.omni-nav__dropdown[open]').forEach(item => {
  if (!item.contains(event.target)) item.open = false;
 });
});
document.addEventListener('keydown', event => {
 if (event.key !== 'Escape') return;
 document.querySelectorAll('.omni-native-shop dropdown-component[data-open="true"]').forEach(menu => { menu.close(); menu.querySelector('button').focus(); });
 const open = event.target.closest('.omni-nav__dropdown[open]');
 if (open) { open.open = false; open.querySelector('summary').focus(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-all-in-app"] && !Shopify.designMode) return;
  try {
    
function initOmniApp(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')];
  let visible=false;
  const play=()=>panels.forEach(p=>{const v=p.querySelector('video');if(!v)return;if(!p.hidden&&visible&&!matchMedia('(prefers-reduced-motion: reduce)').matches)v.play().catch(()=>{});else v.pause();});
  const select=(i)=>{tabs.forEach((t,j)=>{t.setAttribute('aria-selected',j===i);t.tabIndex=j===i?0:-1;panels[j].hidden=j!==i;});play();};
  tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(i));t.addEventListener('keydown',e=>{let j=i;if(e.key==='ArrowRight')j=(i+1)%tabs.length;else if(e.key==='ArrowLeft')j=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')j=0;else if(e.key==='End')j=tabs.length-1;else return;e.preventDefault();select(j);tabs[j].focus();});});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;play();},{threshold:.1}).observe(root);
}
document.querySelectorAll('.oaa').forEach(initOmniApp);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.oaa').forEach(initOmniApp));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-home-learn"] && !Shopify.designMode) return;
  try {
    
function initOmniLearn(root){root.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{const list=root.querySelector('.ohl-cards');list.scrollBy({left:Number(button.dataset.step)*(list.clientWidth+24)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));}
document.querySelectorAll('.ohl').forEach(initOmniLearn);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ohl').forEach(initOmniLearn));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-home-reviews"] && !Shopify.designMode) return;
  try {
    
function layoutOmniReviews(root){const columns=[...root.querySelectorAll('.ohr-track')];const cards=[...root.querySelectorAll('.ohr-card')];cards.forEach((c,i)=>c.dataset.reviewOrder=i);const update=()=>{const count=matchMedia('(max-width:989px)').matches?2:3;cards.forEach((card,i)=>columns[i%count].appendChild(card));};update();matchMedia('(max-width:989px)').addEventListener('change',update);}
document.querySelectorAll('.ohr').forEach(layoutOmniReviews);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ohr').forEach(layoutOmniReviews));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-stories"] && !Shopify.designMode) return;
  try {
    
function initOmniStories(scope) {
 scope.querySelectorAll('.omni-stories:not([data-ready])').forEach(root => {
  root.dataset.ready = 'true';
  const filters = root.querySelector('.omni-stories__filters');
  const cards = [...root.querySelectorAll('[data-story-category]')];
  const status = root.querySelector('[data-story-status]');
  filters.hidden = false;
  const header = document.querySelector('header-component');
  const updateHeader = () => root.style.setProperty('--omni-stories-header-height', (header ? header.getBoundingClientRect().height : 0) + 'px');
  updateHeader();
  const headerObserver = new ResizeObserver(updateHeader);
  if (header) headerObserver.observe(header);
  root.addEventListener('shopify:section:unload', () => headerObserver.disconnect(), {once:true});
  filters.addEventListener('click', event => {
   const button = event.target.closest('[data-story-filter]');
   if (!button) return;
   filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
   let count = 0;
   cards.forEach(card => {
    card.hidden = button.dataset.storyFilter !== 'all' && card.dataset.storyCategory !== button.dataset.storyFilter;
    if (!card.hidden && card.getClientRects().length) count++;
    if (card.hidden) card.querySelectorAll("video,audio").forEach(video => video.pause());
   });
   status.textContent = count + ' ' + status.dataset.countLabel;
  });
 });
}
initOmniStories(document);
document.addEventListener('shopify:section:load', () => initOmniStories(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-sup-faq"] && !Shopify.designMode) return;
  try {
    
function initOmniFaq(scope) {
 scope.querySelectorAll('.omni-faq:not([data-ready])').forEach(root => {
  root.dataset.ready = 'true';
  const bar = root.querySelector('.omni-faq__sidebar');
  const nav = bar.querySelector('nav');
  const links = [...nav.querySelectorAll('a')];
  const groups = [...root.querySelectorAll('.omni-faq__group')];
  const header = document.querySelector('.section-header');
  let pending = false, active = '';
  const update = () => {
   pending = false;
   const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
   root.style.setProperty('--faq-header', headerBottom + 'px');
   root.style.setProperty('--faq-offset', (headerBottom + bar.offsetHeight + 24) + 'px');
   const line = headerBottom + bar.offsetHeight + 40;
   let current = groups[0];
   groups.forEach(group => { if (group.getBoundingClientRect().top <= line) current = group; });
   if (!current || active === current.id) return;
   active = current.id;
   links.forEach(link => {
    const selected = link.hash === '#' + active;
    if(selected) {
     link.setAttribute('aria-current','location');
     nav.scrollTo({left:link.offsetLeft - nav.offsetLeft - (nav.clientWidth - link.offsetWidth)/2, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    } else link.removeAttribute('aria-current');
   });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  root.addEventListener('click', event => {
   const link = event.target.closest('a[href^="#faq-"]');
   if (!link) return;
   const target = document.getElementById(link.hash.slice(1));
   if (!target) return;
   event.preventDefault(); update();
   const offset = (header ? header.offsetHeight : 0) + bar.offsetHeight + 24;
   window.scrollTo({top:window.scrollY + target.getBoundingClientRect().top - offset, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   history.replaceState(null,'',link.hash);
  });
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  const resize = new ResizeObserver(schedule); resize.observe(bar); if(header) resize.observe(header);
  root.addEventListener('toggle',schedule,true);
  update();
  document.addEventListener('shopify:section:unload', event => {
   if (!event.target.contains(root)) return;
   window.removeEventListener('scroll',schedule); window.removeEventListener('resize',schedule); resize.disconnect();
  });
 });
}
initOmniFaq(document);
document.addEventListener('shopify:section:load', () => initOmniFaq(document));

  } catch(e) { console.error(e); }
})();
})();
